import { render, staticRenderFns } from "./CardForm.vue?vue&type=template&id=c06145d0&"
import script from "./CardForm.vue?vue&type=script&lang=ts&"
export * from "./CardForm.vue?vue&type=script&lang=ts&"
import style0 from "./CardForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports